import React, { useState, useEffect, useRef, useMemo } from 'react';

const ScrollingNumber = ({ value, duration = 2000, prefix = '', suffix = '' }) => {
  const [currentValue, setCurrentValue] = useState(0);
  const elementRef = useRef(null);
  const startTime = useRef(null);
  const numericValue = useMemo(() => parseFloat(String(value).replace(/[^0-9.]/g, '')) || 0, [value]);

  useEffect(() => {
    startTime.current = null;

    const animate = (timestamp) => {
      if (!startTime.current) startTime.current = timestamp;
      const progress = timestamp - startTime.current;
      const percentage = Math.min(progress / duration, 1);
      const easeOutQuart = 1 - Math.pow(1 - percentage, 4);
      const current = Math.floor(numericValue * easeOutQuart);
      setCurrentValue(current);

      if (percentage < 1) {
        requestAnimationFrame(animate);
      } else {
        setCurrentValue(numericValue);
      }
    };

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          requestAnimationFrame(animate);
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );

    if (elementRef.current) {
      observer.observe(elementRef.current);
    }

    return () => observer.disconnect();
  }, [duration, numericValue]);

  return (
    <span ref={elementRef} className="scrolling-number">
      {prefix}{currentValue.toLocaleString()}{suffix}
    </span>
  );
};

export default ScrollingNumber;
